import React,{useState} from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiPlus,FiMinus}=FiIcons;

const FAQItem=({question,answer,isOpen,toggle})=> (
  <div className="border-b border-sand">
    <button onClick={toggle} className="w-full py-6 flex justify-between items-center text-left hover:text-ube transition-colors group">
      <span className="font-serif text-xl md:text-2xl text-gray-900 group-hover:text-ube transition-colors">{question}</span>
      <SafeIcon icon={isOpen ? FiMinus : FiPlus} className="w-5 h-5 text-ube flex-shrink-0 ml-4" />
    </button>
    <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] pb-8' : 'max-h-0'}`}>
      <p className="text-gray-600 leading-relaxed text-lg">{answer}</p>
    </div>
  </div>
);

const FAQ=()=> {
  const [openIndex,setOpenIndex]=useState(null);
  const faqData=[
    {group: "About ube & UBEA",items: [
      {q: "What is ube?",a: "Ube is a purple yam native to the Philippines, loved for generations for its naturally deep violet color and its flavor — soft notes of vanilla, coconut, and toasted nut."},
      {q: "Where does UBEA ube come from?",a: "Family farms in the Philippines — and we can source other Philippine ube varieties on request. Our ube is grown and dried in the Philippines, then shipped from Manila through the Port of Los Angeles, California."}
    ]},
    {group: "Orders, shipping & subscriptions",items: [
      {q: "Where do you ship from, and how much is shipping?",a: "Everything ships from Manila through the Port of Los Angeles, California. US shipping is free on orders over $75."},
      {q: "How do I contact you?",a: "You'll always hear back from a real person on our team — we read and answer every message ourselves, usually within one business day."}
    ]}
  ];

  return (
    <div className="bg-white min-h-screen pt-12 pb-24 font-sans">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="font-serif text-5xl md:text-6xl text-gray-900 mb-6">FAQ</h1>
          <p className="text-gray-600 text-lg">Everything you need to know about real ube.</p>
        </div>
        <div className="space-y-16">
          {faqData.map((group,groupIdx)=> (
            <div key={groupIdx}>
              <h2 className="font-serif text-2xl text-ube border-b-2 border-sand pb-4 mb-4 uppercase tracking-widest font-bold">{group.group}</h2>
              <div className="divide-y divide-sand">
                {group.items.map((item,itemIdx)=> {
                  const globalIdx=`${groupIdx}-${itemIdx}`;
                  return <FAQItem key={itemIdx} question={item.q} answer={item.a} isOpen={openIndex===globalIdx} toggle={()=> setOpenIndex(openIndex===globalIdx ? null : globalIdx)} />;
                })}
              </div>
            </div>
          ))}
        </div>
        <div className="mt-24 bg-sand-light rounded-[3rem] p-12 text-center border border-sand">
          <h3 className="font-serif text-3xl text-gray-900 mb-4">Still have questions?</h3>
          <p className="text-gray-600 mb-8 max-w-md mx-auto">You'll always hear back from a real person on our team — we read and answer every message ourselves, usually within one business day.</p>
          <button className="bg-ube text-white px-8 py-3 rounded-full font-bold hover:bg-ube-light transition-colors">Contact Us</button>
        </div>
      </div>
    </div>
  );
};

export default FAQ;